module.exports = __webpack_public_path__ + "img/pro_nine_2.c7e7876e.jpg";